var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('Loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("View/Update Tax Invoice")])]), _vm._v(" "), _c('b-card', [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', [_c('label', [_vm._v("AWB No")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label'), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-shopping-cart'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumber),
      expression: "awbnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumber')
    },
    attrs: {
      "type": "text",
      "placeholder": "Please enter AWB Number",
      "name": "awbnumber",
      "id": "awbnumber"
    },
    domProps: {
      "value": (_vm.awbnumber)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.getFTCDetails($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "text-danger errormsg"
  }, [_vm._v(_vm._s(_vm.awbErr))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5",
    staticStyle: {
      "top": "-6px"
    }
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getFTCDetails
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v("\n                      Search")]), _vm._v("   \n                    "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])])])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFTCdetails),
      expression: "showFTCdetails"
    }]
  }, [_c('div', {
    staticClass: "card-header-tab"
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button ', {
        active: _vm.currentTab === tab.key
      }],
      attrs: {
        "title": tab.value
      },
      on: {
        "click": function($event) {
          _vm.onTabClick(tab.key)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n            "), (tab.value == 'Edit FTC Charges') ? _c('span', {
      attrs: {
        "id": "second"
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (tab.value == 'View Tax Invoice') ? _c('span', {
      attrs: {
        "id": "first"
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text-o"
    })]) : _vm._e()])
  })), _vm._v(" "), _c('b-card', [(_vm.currentTab == 'First') ? _c('fieldset', [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "0.5rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printCashMemo
    }
  }, [_vm._v("Print")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCashMemoData"
    }
  }, _vm._l((_vm.printAwb), function(item) {
    return _c('FTCMemoDepositSlip', {
      key: item.AWB,
      attrs: {
        "selectedData": item
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.currentTab == 'Second') ? _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_vm._v("\n             \n          "), _c('button', {
    staticClass: "btn1 btn-danger",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickConfirmAction
    }
  }, [_vm._v("Confirm FTC Amount")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("A + B + C + D")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-badge', {
    attrs: {
      "variant": "warn_info"
    }
  }, [_vm._v("Total FTC Amount (INR) :"), _c('span', [_vm._v(_vm._s(Number(_vm.ftctotalamtwogst).toFixed(2).toLocaleString()))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 mt-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("A + B + C + D + E")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mt-2"
  }, [_c('b-badge', {
    attrs: {
      "variant": "warn_info"
    }
  }, [_vm._v("Total FTC Amount (INR) (Including GST):"), _c('span', [_vm._v(_vm._s(Number(_vm.totalFTCamount).toFixed(2)))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "AssignedBA/SR",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("A. Freight Charges (" + _vm._s(Number(_vm.totalfreightcharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Weights")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "Weights"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("W1. Volumetric Weight (kg):")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.volweight),
      expression: "volweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('volweight')
    },
    attrs: {
      "type": "text",
      "name": "volweight",
      "id": "volweight",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.volweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.volweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('volweight')),
      expression: "errors.has('volweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter volumetric weight.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("W2. Physical Weight (kg):")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phyweight),
      expression: "phyweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('phyweight')
    },
    attrs: {
      "type": "text",
      "name": "phyweight",
      "id": "phyweight",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.phyweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phyweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phyweight')),
      expression: "errors.has('phyweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter physical weight.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                          W3. Applicable Weight (kg):"), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Max of 1 and 2)")])]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.apliweight),
      expression: "apliweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('apliweight')
    },
    attrs: {
      "type": "text",
      "name": "apliweight",
      "id": "apliweight",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.apliweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.apliweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('apliweight')),
      expression: "errors.has('apliweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter applicable weight.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("W4. Minimum Chargeable Weight (kg):")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chargeweight),
      expression: "chargeweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('chargeweight')
    },
    attrs: {
      "type": "text",
      "name": "chargeweight",
      "id": "chargeweight",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.chargeweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chargeweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('chargeweight')),
      expression: "errors.has('chargeweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter minimum chargeable.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("\n                          W5. Bill Weight (kg):"), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Max of W3 and W4)")])]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.billweight),
      expression: "billweight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('billweight')
    },
    attrs: {
      "type": "text",
      "name": "billweight",
      "id": "billweight",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.billweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.billweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('billweight')),
      expression: "errors.has('billweight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter bill weight.")])], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Charge Calculation")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%",
      "height": "167px"
    },
    attrs: {
      "id": "chargecal"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("\n                          C1. Freight rate for the lane (INR per kg):\n                        ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freightrate),
      expression: "freightrate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('freightrate')
    },
    attrs: {
      "type": "text",
      "name": "freightrate",
      "id": "freightrate",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.freightrate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freightrate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('freightrate')),
      expression: "errors.has('freightrate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter freight rate.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "45%"
    }
  }, [_vm._v("\n                          C2. Freight Charges (INR): "), _c('br'), _c('span', {
    staticStyle: {
      "font-weight": "100",
      "font-style": "italic"
    }
  }, [_vm._v("(Higher of\n                            \"C1 x W5\" or Minimum Docket Amount)")])]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.freightcharge),
      expression: "freightcharge"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('freightcharge')
    },
    attrs: {
      "type": "text",
      "name": "freightcharge",
      "id": "freightcharge",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.freightcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.freightcharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('freightcharge')),
      expression: "errors.has('freightcharge')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter freight charges.")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("B. Insurance Charges (" + _vm._s(Number(_vm.totalinsurancecharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "insurancecharge"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "37%"
    }
  }, [_vm._v("Applicable charge:")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.applicablecharge) + "\n                        ")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "28%"
    }
  }, [_vm._v(_vm._s(_vm.applicablecharge) + " Charge Type:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.FOVchargetype))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.applicablecharge) + "% type")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.type))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Rate (%):")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rate')
    },
    attrs: {
      "type": "text",
      "name": "rate",
      "id": "rate",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rate')),
      expression: "errors.has('rate')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter rate.")])], 1), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Limits ( Charges) (INR)")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Min")]), _vm._v(" "), _c('td', [_vm._v("\n                          " + _vm._s(_vm.min) + "\n                        ")]), _vm._v(" "), _c('th', [_vm._v("Max")]), _vm._v(" "), _c('td', [_vm._v("\n                           " + _vm._s(_vm.max) + "\n                        ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('legend', [_vm._v(" Charge Calculation")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%",
      "height": "133px"
    },
    attrs: {
      "id": "chargecal"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("Invoice Value (INR):")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoicevalue),
      expression: "invoicevalue"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('invoicevalue')
    },
    attrs: {
      "type": "text",
      "name": "invoicevalue",
      "id": "invoicevalue",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.invoicevalue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoicevalue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('invoicevalue')),
      expression: "errors.has('invoicevalue')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter invoice value.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("Charges (INR) :")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.charges),
      expression: "charges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('charges')
    },
    attrs: {
      "type": "text",
      "name": "charges",
      "id": "charges",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.charges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.charges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('charges')),
      expression: "errors.has('charges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter charges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "width": "50%"
    }
  }, [_vm._v("Charges payable (INR) :")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payblecharges),
      expression: "payblecharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('payblecharges')
    },
    attrs: {
      "type": "text",
      "name": "payblecharges",
      "id": "payblecharges",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.payblecharges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payblecharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('payblecharges')),
      expression: "errors.has('payblecharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter payblecharges.")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("C. Accessorial Charges (" + _vm._s(Number(_vm.totalaccessorialCharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "accesocharge"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Waybill Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.waybillcharges),
      expression: "waybillcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('waybillcharges')
    },
    attrs: {
      "type": "text",
      "name": "waybillcharges",
      "id": "waybillcharges"
    },
    domProps: {
      "value": (_vm.waybillcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.waybillcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('waybillcharges')),
      expression: "errors.has('waybillcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter waybillcharges.")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "width": "27%"
    }
  }, [_vm._v("\n                          Appointment/ Different Vehicle Charges:\n                        ")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehiclecharges),
      expression: "vehiclecharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('vehiclecharges')
    },
    attrs: {
      "type": "text",
      "name": "vehiclecharges",
      "id": "vehiclecharges"
    },
    domProps: {
      "value": (_vm.vehiclecharges)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.vehiclecharges = $event.target.value
      }, _vm.onChange],
      "keypress": function($event) {
        _vm.isNumber($event)
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('vehiclecharges')),
      expression: "errors.has('vehiclecharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter vehiclecharges.")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("RTO Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rtocharges),
      expression: "rtocharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('rtocharges')
    },
    attrs: {
      "type": "text",
      "name": "rtocharges",
      "id": "rtocharges"
    },
    domProps: {
      "value": (_vm.rtocharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rtocharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rtocharges')),
      expression: "errors.has('rtocharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter rtocharges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("DC Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dccharges),
      expression: "dccharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('dccharges')
    },
    attrs: {
      "type": "text",
      "name": "dccharges",
      "id": "dccharges"
    },
    domProps: {
      "value": (_vm.dccharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dccharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dccharges')),
      expression: "errors.has('dccharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter dccharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Loading/Unloading Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadingcharges),
      expression: "loadingcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('loadingcharges')
    },
    attrs: {
      "type": "text",
      "name": "loadingcharges",
      "id": "loadingcharges",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.loadingcharges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loadingcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('loadingcharges')),
      expression: "errors.has('loadingcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter loadingcharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("ODA charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odacharges),
      expression: "odacharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('odacharges')
    },
    attrs: {
      "type": "text",
      "name": "odacharges",
      "id": "odacharges"
    },
    domProps: {
      "value": (_vm.odacharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odacharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odacharges')),
      expression: "errors.has('odacharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter odacharges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("FTC (To Pay) Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ftccharges),
      expression: "ftccharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('ftccharges')
    },
    attrs: {
      "type": "text",
      "name": "ftccharges",
      "id": "ftccharges"
    },
    domProps: {
      "value": (_vm.ftccharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftccharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ftccharges')),
      expression: "errors.has('ftccharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter ftccharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Open pickup/delivery charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliverycharges),
      expression: "deliverycharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('deliverycharges')
    },
    attrs: {
      "type": "text",
      "name": "deliverycharges",
      "id": "deliverycharges"
    },
    domProps: {
      "value": (_vm.deliverycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliverycharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliverycharges')),
      expression: "errors.has('deliverycharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter deliverycharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Holiday delivery charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holidaycharges),
      expression: "holidaycharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('holidaycharges')
    },
    attrs: {
      "type": "text",
      "name": "holidaycharges",
      "id": "holidaycharges"
    },
    domProps: {
      "value": (_vm.holidaycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.holidaycharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('holidaycharges')),
      expression: "errors.has('holidaycharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter holidaycharges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fuel Surcharge:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fuelcharges),
      expression: "fuelcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fuelcharges')
    },
    attrs: {
      "type": "text",
      "name": "fuelcharges",
      "id": "fuelcharges"
    },
    domProps: {
      "value": (_vm.fuelcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fuelcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fuelcharges')),
      expression: "errors.has('fuelcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter fuelcharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Handling Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.handlingcharges),
      expression: "handlingcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('handlingcharges')
    },
    attrs: {
      "type": "text",
      "name": "handlingcharges",
      "id": "handlingcharges"
    },
    domProps: {
      "value": (_vm.handlingcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.handlingcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('handlingcharges')),
      expression: "errors.has('handlingcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter handlingcharges.")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Delivery Attempt Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryattempcharges),
      expression: "deliveryattempcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('deliveryattempcharges')
    },
    attrs: {
      "type": "text",
      "name": "deliveryattempcharges",
      "id": "deliveryattempcharges"
    },
    domProps: {
      "value": (_vm.deliveryattempcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryattempcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliveryattempcharges')),
      expression: "errors.has('deliveryattempcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter deliveryattempcharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Delivery above ground floor charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grounfloorcharges),
      expression: "grounfloorcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('grounfloorcharges')
    },
    attrs: {
      "type": "text",
      "name": "grounfloorcharges",
      "id": "grounfloorcharges"
    },
    domProps: {
      "value": (_vm.grounfloorcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.grounfloorcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('grounfloorcharges')),
      expression: "errors.has('grounfloorcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter grounfloorcharges.")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Demurrage Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.demurragecharges),
      expression: "demurragecharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('demurragecharges')
    },
    attrs: {
      "type": "text",
      "name": "demurragecharges",
      "id": "demurragecharges"
    },
    domProps: {
      "value": (_vm.demurragecharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.demurragecharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('demurragecharges')),
      expression: "errors.has('demurragecharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter demurragecharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Green Tax:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.greentax),
      expression: "greentax"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('greentax')
    },
    attrs: {
      "type": "text",
      "name": "greentax",
      "id": "greentax"
    },
    domProps: {
      "value": (_vm.greentax)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.greentax = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('greentax')),
      expression: "errors.has('greentax')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter greentax.")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("D. AWB Extra Charges (" + _vm._s(Number(_vm.totalawbextracharges).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "extracharge"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "18%"
    }
  }, [_vm._v("Shipment Sized Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentsizecharges),
      expression: "shipmentsizecharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('shipmentsizecharges')
    },
    attrs: {
      "type": "text",
      "name": "shipmentsizecharges",
      "id": "shipmentsizecharges"
    },
    domProps: {
      "value": (_vm.shipmentsizecharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentsizecharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shipmentsizecharges')),
      expression: "errors.has('shipmentsizecharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter shipmentsizecharges.")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "width": "27%"
    }
  }, [_vm._v("Mathadi/Varai Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mathadicharges),
      expression: "mathadicharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('mathadicharges')
    },
    attrs: {
      "type": "text",
      "name": "mathadicharges",
      "id": "mathadicharges"
    },
    domProps: {
      "value": (_vm.mathadicharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mathadicharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('mathadicharges')),
      expression: "errors.has('mathadicharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter mathadicharges.")])], 1), _vm._v(" "), _c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Portgages Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.portgagescharges),
      expression: "portgagescharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('portgagescharges')
    },
    attrs: {
      "type": "text",
      "name": "portgagescharges",
      "id": "portgagescharges"
    },
    domProps: {
      "value": (_vm.portgagescharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.portgagescharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('portgagescharges')),
      expression: "errors.has('portgagescharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter portgagescharges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Special Delivery Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specialdeliverycharges),
      expression: "specialdeliverycharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('specialdeliverycharges')
    },
    attrs: {
      "type": "text",
      "name": "specialdeliverycharges",
      "id": "specialdeliverycharges"
    },
    domProps: {
      "value": (_vm.specialdeliverycharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.specialdeliverycharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('specialdeliverycharges')),
      expression: "errors.has('specialdeliverycharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter specialdeliverycharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("Loading/Unloading Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.unloadingcharges),
      expression: "unloadingcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('unloadingcharges')
    },
    attrs: {
      "type": "text",
      "name": "unloadingcharges",
      "id": "unloadingcharges"
    },
    domProps: {
      "value": (_vm.unloadingcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.unloadingcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('unloadingcharges')),
      expression: "errors.has('unloadingcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter unloadingcharges.")])], 1), _vm._v(" "), _c('th', [_vm._v("ODA Charges:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.odaawbcharges),
      expression: "odaawbcharges"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('odaawbcharges')
    },
    attrs: {
      "type": "text",
      "name": "odaawbcharges",
      "id": "odaawbcharges"
    },
    domProps: {
      "value": (_vm.odaawbcharges)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.odaawbcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('odaawbcharges')),
      expression: "errors.has('odaawbcharges')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter odaawbcharges.")])], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Full Truck Load:")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fulltruckload),
      expression: "fulltruckload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('fulltruckload')
    },
    attrs: {
      "type": "text",
      "name": "fulltruckload",
      "id": "fulltruckload"
    },
    domProps: {
      "value": (_vm.fulltruckload)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fulltruckload = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('fulltruckload')),
      expression: "errors.has('fulltruckload')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter fulltruckload.")])], 1), _vm._v(" "), _c('th'), _vm._v(" "), _c('td'), _vm._v(" "), _c('th'), _vm._v(" "), _c('td')])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "Shipments",
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("E. GST " + _vm._s(_vm.gst) + "% (" + _vm._s(Number((_vm.ftctotalamtwogst / 100) * _vm.gst).toFixed(2).toLocaleString()) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "styled-table1",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "gst"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v("GST :")]), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gst),
      expression: "gst"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('gst')
    },
    attrs: {
      "type": "text",
      "name": "gst",
      "id": "gst",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.gst)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gst = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gst')),
      expression: "errors.has('gst')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please enter gst.")])], 1), _vm._v(" "), _c('td', {
    attrs: {
      "width": "75%"
    }
  }), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])])])])])])])])])])]) : _vm._e(), _vm._v(" "), _c('div')])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "xl"
    },
    on: {
      "ok": function($event) {
        _vm.showFTCAmount = false
      }
    },
    model: {
      value: (_vm.showFTCAmount),
      callback: function($$v) {
        _vm.showFTCAmount = $$v
      },
      expression: "showFTCAmount"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Action Confirmation: Confirm FTC Amount")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showFTCAmount = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 ConfirmMessage"
  }, [_c('h6', [_vm._v("A. Freight Charges - " + _vm._s(Number(_vm.totalfreightcharges).toFixed(2).toLocaleString()) + " ")]), _vm._v(" "), _c('h6', [_vm._v("B. Insurance Charges - " + _vm._s(Number(_vm.totalinsurancecharges).toFixed(2).toLocaleString()) + " ")]), _vm._v(" "), _c('h6', [_vm._v("C. Accessorial Charges - " + _vm._s(Number(_vm.totalaccessorialCharges).toFixed(2).toLocaleString()) + " ")]), _vm._v(" "), _c('h6', [_vm._v("D. AWB Extra Charges - " + _vm._s(Number(_vm.totalawbextracharges).toFixed(2).toLocaleString()) + " ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Total Charges (INR) - " + _vm._s(Number(_vm.ftctotalamtwogst).toFixed(2).toLocaleString()))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v(" GST " + _vm._s(_vm.gst) + "% (INR) - " + _vm._s(Number((_vm.ftctotalamtwogst / 100) * _vm.gst).toFixed(2).toLocaleString()) + " ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', {
    staticStyle: {
      "font-weight": "bolder"
    }
  }, [_vm._v("Total Charges (INR) (Including " + _vm._s(_vm.gst) + "% gst) - " + _vm._s(Math.round(Number(_vm.totalFTCamount)).toFixed(2).toLocaleString()))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateFTCCharges
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeconfirmtab
    }
  }, [_vm._v("No")])])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.showPrintCashMemo = false
      }
    },
    model: {
      value: (_vm.showPrintCashMemo),
      callback: function($$v) {
        _vm.showPrintCashMemo = $$v
      },
      expression: "showPrintCashMemo"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("View/Print Tax Invoice")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showPrintCashMemo = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('fieldset', [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-bottom": "0.5rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.printCashMemo
    }
  }, [_vm._v("Print")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "printCashMemoData"
    }
  }, _vm._l((_vm.printAwb), function(item) {
    return _c('FTCMemoDepositSlip', {
      key: item.AWB,
      attrs: {
        "selectedData": item
      }
    })
  }))]), _vm._v(" "), _c('br')])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7737f475","hasScoped":true}!./src/modules/utility/views/updateFTCcharges/updateFTCcharges.component.html
// module id = 2165
// module chunks = 3